import React, { useEffect, useState } from 'react';
import { BrookfieldAvatar } from './components/BrookfieldAvatar';
import { AvatarControls, AvatarState } from './components/AvatarControls';
import { StyleSwitcher, AvatarStyleType } from './components/StyleSwitcher';
export function App() {
  const [avatarState, setAvatarState] = useState<AvatarState>('idle');
  const [visualStyle, setVisualStyle] = useState<AvatarStyleType>('gradient1');
  // Keyboard shortcuts for styles
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (['1', '2', '3', '4', '5'].includes(e.key)) {
        const styles: AvatarStyleType[] = ['gradient1', 'gradient2', 'gradient3', 'gradient4', 'gradient5'];
        setVisualStyle(styles[parseInt(e.key) - 1]);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
  // Dynamic background based on style
  const getBackground = () => {
    return 'bg-[#F5F5F5]';
  };
  return <main className={`min-h-screen w-full ${getBackground()} text-white flex flex-col items-center justify-center overflow-hidden relative selection:bg-blue-500/30 transition-colors duration-1000`} data-id="element-0">
      {/* Background ambient glow - changes with style */}
      <div className="absolute inset-0 pointer-events-none transition-opacity duration-1000" style={{
      opacity: visualStyle === 'aura' ? 0.8 : 0.5
    }} data-id="element-1">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120vw] h-[120vw] bg-[radial-gradient(circle_at_center,rgba(0,26,51,0.4)_0%,rgba(5,10,20,0)_60%)]" data-id="element-2" />
      </div>

      {/* Main Content Container */}
      <div className="relative z-10 flex flex-col items-center justify-center w-full h-full max-w-5xl mx-auto px-4 py-8" data-id="element-3">
        {/* Avatar Container */}
        <div className="flex-1 flex items-center justify-center w-full min-h-[500px]" data-id="element-4">
          <BrookfieldAvatar state={avatarState} visualStyle={visualStyle} data-id="element-5" />
        </div>

        {/* Controls Container */}
        <div className="mt-8 mb-12" data-id="element-6">
          <AvatarControls currentState={avatarState} onStateChange={setAvatarState} data-id="element-7" />
        </div>
      </div>

      {/* Style Switcher */}
      <StyleSwitcher currentStyle={visualStyle} onStyleChange={setVisualStyle} data-id="element-8" />
    </main>;
}